<template>
  <div class="the-menu">
    <router-link to="/" class="the-menu__headline">
      <img :src="$t('app.contestLogo')" />
    </router-link>

    <ul class="the-menu__items">
      <li class="the-menu__item">
        <router-link to="/gallery" class="the-menu__link">{{ $t('menu.gallery') }}</router-link>
      </li>

      <li class="the-menu__item">
        <router-link to="/contest" class="the-menu__link">{{ $t('menu.contest') }}</router-link>
      </li>

      <li class="the-menu__item">
        <router-link to="/language" class="the-menu__link the-menu__link--icon">{{ $t('menu.language') }} <img :src="$t('menu.language.icon')" /></router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TheMenu',
};
</script>

<style lang="scss">
.the-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding-left: 60px;

  @media screen and (max-width: 1650px) {
    display: block;
    padding-left: 0;
  }

  &__headline {
    max-width: 600px;

    @media screen and (max-width: 1650px) {
      display: block;
      max-width: 600px;
      margin: 0 auto 20px;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  &__items {
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 1650px) {
      padding: 0 20px;
      flex-wrap: wrap;
    }
  }

  &__item {
    margin-left: 30px;
    padding: 25px 50px 25px 60px;

    background-color: #0e76bc;

    transform: skewX(-20deg);
    transform-origin: bottom left;

    @media screen and (max-width: 1650px) {
      margin: 20px;
    }

    @media screen and (max-width: 1080px) {
      display: block;
      width: 100%;
      margin: 20px;
    }
  }

  &__link {
    display: block;
    font-size: 26px;
    font-weight: bold;
    text-decoration: none;
    text-transform: uppercase;
    color: inherit;

    transform: skewX(20deg);
    transform-origin: bottom left;

    &--icon {
      position: relative;
      padding-right: 70px;

      img {
        position: absolute;
        right: 0;
        top: 50%;
        width: 50px;

        transform: translateY(-50%);
      }
    }

    &:hover {
      color: #ffff00;
    }
  }
}
</style>
